// R11P GEOLOGICAL P0.6-NITA-02A — API origin, liveness and readiness URLs.
//
// The Portal's API base is the /api resource prefix (production
// https://api.giisdec.com/api). The Geological API's probes are NOT under
// that prefix: liveness is GET <origin>/health and readiness GET <origin>/status
// (the versioned probes live under /api/v1). There is no /api/health, so a probe
// built as `${base}/health` reaches a 404 — which must never read as healthy.
//
// Pure module (no imports) so the derivation is unit-testable.

/** Strip a trailing "/api" (and slashes) from the configured base. "" means same origin. */
export function deriveApiOrigin(base: string | undefined | null): string {
  const raw = String(base ?? '').trim().replace(/\/+$/, '');
  if (!raw) return '';
  const withoutApi = raw.replace(/\/api$/i, '');
  return withoutApi.replace(/\/+$/, '');
}

/** GET <origin>/health — liveness. */
export function healthUrl(base: string | undefined | null): string {
  return `${deriveApiOrigin(base)}/health`;
}

/** GET <origin>/status — readiness. */
export function statusUrl(base: string | undefined | null): string {
  return `${deriveApiOrigin(base)}/status`;
}

/** Only a 2xx answer means the probe succeeded. 0 (network), 3xx, 4xx (incl. 404) and 5xx do not. */
export function isProbeHealthy(httpStatus: number): boolean {
  return Number.isInteger(httpStatus) && httpStatus >= 200 && httpStatus < 300;
}
